








import { Component, Prop, Vue } from "vue-property-decorator";
import gtSelectTenant from "./components/selectTenant.vue";

@Component({
  components: { gtSelectTenant }
})
export default class Tenant extends Vue {
  created() {
    if (!localStorage.getItem("AuthToken")) {
      this.$router.push({ path: "/login" });
    }
  }
  async onSelectHandle() {
    const route = (this as any).$route;
    (this as any).$router.push({ name: "Home", query: route.query });
  }
}
